import { ApisOverview } from '../apisOverview/ApisOverview';
import { AsyncApisMessagesApp } from '@internal/backstage-plugin-zf-async-apis-messages';
import { TabConfig } from './ITabConfig.interface';
import { useLocation } from 'react-router-dom';
import {
  Header,
  Page,
  TabbedLayout,
} from '@backstage/core-components';

const tabs: TabConfig[] = [
  {
    path: '/',
    title: 'Overview',
    component: ApisOverview,
  },
  {
    path: '/messages',
    title: 'Messages',
    component: AsyncApisMessagesApp,
  },
];

export const ApisPage = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);
  const isNestedRoute = pathSegments.length > 2;

  if (isNestedRoute) {
    // First, try to find a specific named tab that matches the path segments
    // We skip the root tab (/) first to give named tabs priority
    // If we checked the root tab first, it would always match and we'd never render the correct specific tab component
    let currentTab = tabs.find(tab => {
      if (tab.path === '/') return false;
      return pathSegments.includes(tab.path.substring(1));
    });

    if (!currentTab) {
      currentTab = tabs.find(tab => tab.path === '/');
    }

    if (currentTab) {
      const Component = currentTab.component;
      return <Component />;
    }
  }

  return (
    <Page themeId="apis">
      <Header
        title="APIs"
        subtitle="Definitions, relationships, and details of the OpenAPI and AsyncAPI specifications"
      />

      <TabbedLayout>
        {tabs.map(tab => (
          <TabbedLayout.Route path={tab.path} title={tab.title}>
            <tab.component />
          </TabbedLayout.Route>
        ))}
      </TabbedLayout>
    </Page>
  );
};
